import { BaseFetch } from "../main-model"
export default class PeriodModel extends BaseFetch {
  getPeriodBy = (data) =>
    this.authFetch({
      url: "period/getPeriodBy",
      method: "POST",
      body: JSON.stringify(data),
    })
  getPeriodById = (data) =>
    this.authFetch({
      url: "period/getPeriodById",
      method: "POST",
      body: JSON.stringify(data),
    })
    updatePeriodById = (data) =>
    this.authFetch({
      url: "period/updatePeriodById",
      method: "POST",
      body: JSON.stringify(data),
    })
    insertPeriod = (data) =>
    this.authFetch({
      url: "period/insertPeriod",
      method: "POST",
      body: JSON.stringify(data),
    })
    deletePeriodById = (data) =>
    this.authFetch({
      url: "period/deletePeriodById",
      method: "POST",
      body: JSON.stringify(data),
    })
}
